import apiClient from '@/services/apiClient';

const P = '/jw-transfer';

export const jwTransferApi = {
  status: (kind, refs) => apiClient.post(`${P}/ewb-status`, { kind, refs }).then((r) => r.data.items),
  pdf: (kind, ref) => apiClient.get(`${P}/pdf`, { params: { kind, ref }, responseType: 'blob' })
    .then((r) => new Blob([r.data], { type: 'application/pdf' })),
};

/** Error text of a blob request (the JSON detail comes back as a Blob). */
export const blobErr = async (e, fallback) => {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try { return JSON.parse(await d.text()).detail || fallback; } catch { return fallback; }
  }
  return (typeof d?.detail === 'string' && d.detail) || fallback;
};
